import PageComponent from '../base/PageComponent';
import 'bootstrap3/js/collapse';

export default class Header extends PageComponent
{
    init() {
        this.bindEvents();
    }

    bindEvents() {
        this.element.on('click', '.header__search', (e) => {
            e.preventDefault();
            this.toggleSearch();
        });
    }

    /**
     * Returns the container for the search form.
     *
     * @returns {*|jQuery|HTMLElement}
     */
    getSearchFormContainer() {
        return $('.search-form');
    }

    /**
     * Toggles visibility of the search form.
     */
    toggleSearch() {
        let search = this.getSearchFormContainer();

        // use js animations, css won't work in ie9
        if (!search.hasClass('open')) {
            search.stop().slideDown('fast', () => search.addClass('open'));
        } else {
            search.stop().slideUp('fast', () => search.removeClass('open'));
        }
    }
}
